import React from "react";
import { FaEnvelope } from "react-icons/fa";

const Notifications = ({ enabled, setEnabled }) => {
  return (
    <div className="p-4 bg-white rounded-lg shadow-sm border ">
      <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-4">
        Notification Preferences
      </h3>

      <div className="flex flex-col space-y-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
          
          {/* Title Section */}
          <div className="flex flex-row items-center space-x-3 mb-3 md:mb-0">
            <FaEnvelope className="text-gray-500 text-xl" />
            <h4 className="text-gray-800 font-medium">Email Notifications</h4>
          </div>

          {/* Description */}
          <div className="flex items-center space-x-2 mb-3 md:mb-0 md:ml-4 flex-1">
            <p className="text-sm text-gray-600">
              Receive updates about your campaigns and earnings
            </p>
          </div>

          {/* Toggle - aligned right */}
          <div className="flex justify-end">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={enabled}
                onChange={(e) => setEnabled(e.target.checked)}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-orange-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-orange-500"></div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
